<template>
  <div class="page">
    <a-card title="新建会员卡" :bordered="false" :bodyStyle="{paddingTop:'10px'}"
            :headStyle="{ borderBottom: '0px', fontSize: '18px' }">
      <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules"
                    :label-col="currentFormLayout.labelCol"
                    :wrapper-col="currentFormLayout.wrapperCol"
      >
        <a-form-model-item prop="name" label="会员卡名称">
          <a-input v-model="ruleForm.name" allow-clear :maxLength="10" placeholder="请输入" style="max-width: 400px;"/>
        </a-form-model-item>
        <a-form-model-item label="卡面图片" style="margin-bottom: 0;">
          <div>温馨提示：图片建议上传尺寸为690px*360px，格式.jpg、.png、.jpeg</div>
          <div class="upload-box-card">
            <a-upload
              name="avatar"
              list-type="picture-card"
              class="avatar-uploader"
              :show-upload-list="false"
              :action="actionImageUrl"
              @change="handleChange"
              :before-upload="beforeUploadFile"
            >
              <img v-if="ruleForm.image" :src="ruleForm.image" alt="avatar" class="img-avatar"/>
              <div v-else>
                <a-icon type="plus"/>
                <div class="ant-upload-text">上传</div>
              </div>
            </a-upload>
          </div>
        </a-form-model-item>
        <a-form-model-item label="卡类型" required>
          <a-radio-group name="radioGroup" v-model="ruleForm.cardType" @change="onChangeType">
            <a-radio :value="1">电子卡</a-radio>
            <a-radio :value="2">实体卡</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item prop="denomination" label="面额">
          <a-input v-model="ruleForm.denomination" addon-after="元" style="max-width: 400px;" placeholder="1-5000"/>
        </a-form-model-item>
        <div v-if="ruleForm.cardType==1">
          <a-form-model-item prop="commission" label="分销佣金">
            <a-input v-model="ruleForm.commission" addon-after="元" style="max-width: 400px;" placeholder="请输入"/>
          </a-form-model-item>
        </div>
        <a-form-model-item label="发行数量" style="margin-bottom: 0;" required>
          <a-col :span="5">
            <a-form-model-item>
              <a-select v-model="ruleForm.releaseType" placeholder="请选择">
                <a-select-option :value="1" v-if="ruleForm.cardType==1">不限数量</a-select-option>
                <a-select-option :value="2">自定义数量</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="16" class="pl5">
            <a-form-model-item v-if="ruleForm.releaseType==2" prop="releaseNum">
              <a-input v-model="ruleForm.releaseNum" addonAfter="份" placeholder="1-10000" :maxLength="6"
                       style="max-width:225px"/>
              <span style="margin-left:15px;">会员卡总金额：{{ ruleForm.releaseNum * ruleForm.denomination }}</span>
            </a-form-model-item>
          </a-col>
        </a-form-model-item>
        <a-form-model-item required label="有效期" style="margin-bottom: 0;">
          <a-col :span="5">
            <a-form-model-item>
              <a-select v-model="ruleForm.validityKey" placeholder="请选择">
                <a-select-option :value="1">长期有效</a-select-option>
                <a-select-option :value="2">有效期至</a-select-option>
                <a-select-option :value="3">激活后</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="16" class="pl5">
            <a-form-model-item v-if="ruleForm.validityKey==2" prop="cutOffDate">
              <a-date-picker v-model="ruleForm.cutOffDate" :disabledDate="disabledDate" format="YYYY-MM-DD"
                             @change="onDateChange" style="max-width:225px"/>
            </a-form-model-item>
            <a-form-model-item v-if="ruleForm.validityKey==3" prop="validityValue">
              <a-input v-model="ruleForm.validityValue" addonAfter="天" placeholder="1-1096" :maxLength="4"
                       style="max-width:225px"/>
            </a-form-model-item>
          </a-col>
        </a-form-model-item>
        <div v-if="ruleForm.cardType==1">
          <a-form-model-item prop="saleChannels" label="销售渠道">
            <a-checkbox-group v-model="ruleForm.saleChannels">
              <a-checkbox value="1">官方店可售</a-checkbox>
              <a-checkbox value="2">分销员店可售</a-checkbox>
            </a-checkbox-group>
          </a-form-model-item>
        </div>
        <a-form-model-item label="核销渠道">
          <a-radio-group v-model="ruleForm.writeOffChannel" @change="onChangeRadio">
            <a-radio :value="3">全部店铺</a-radio>
            <a-radio :value="1">官方店可用</a-radio>
            <a-radio :value="2">全部分销店可用</a-radio>
            <a-radio :value="4">官方店和指定分销员店铺</a-radio>
            <a-radio :value="5">指定分销员店铺</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <div v-if="ruleForm.writeOffChannel>3">
          <a-form-model-item label="指定分销员店铺" prop="staffIds">
            <div>
              <a-button type="priamry" @click="onShowShopDialog">选择店铺</a-button>
            </div>
            <div>
              <a-tag
                v-for="(item,index) in ruleForm.staffIds"
                :closable="true"
                color="blue"
                @close="handleStaffClose(item.staffId)"
                :key="item.staffId">
                {{ item.shopName }}
              </a-tag>
            </div>
          </a-form-model-item>
        </div>
        <a-form-model-item label="佣金结算" required>
          <a-radio-group v-model="ruleForm.commissionSettlement">
            <a-radio :value="1">订单使用此会员卡支付佣金不变</a-radio>
            <a-radio :value="2">订单使用此会员卡支付无佣金</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item prop="productCatalog" label="可用品类">
          <a-checkbox-group v-model="ruleForm.productCatalog">
            <a-checkbox
              v-for="item in getCataLogIdList()"
              :key="item.code"
              :value="String(item.code)"
              :disabled="!item.enabled"
            >{{ item.name }}
            </a-checkbox>
          </a-checkbox-group>
        </a-form-model-item>
        <a-form-model-item prop="productSource" label="可用商品来源">
          <a-checkbox-group v-model="ruleForm.productSource">
            <a-checkbox value="0">自有商品</a-checkbox>
            <a-checkbox value="1">平台直采</a-checkbox>
            <a-checkbox value="2">云仓分销</a-checkbox>
          </a-checkbox-group>
        </a-form-model-item>
        <a-form-model-item prop="notice" label="使用须知">
          <a-textarea
            v-model="ruleForm.notice"
            placeholder="2000字以内"
            :maxLength="2000"
            :auto-size="{ minRows: 10, maxRows: 15 }"
          />
        </a-form-model-item>
        <a-form-model-item prop="status" label="状态">
          <a-select allowClear v-model="ruleForm.status" placeholder="请选择" style="max-width:225px">
            <a-select-option :value="1">未开始</a-select-option>
            <a-select-option :value="2">发行中</a-select-option>
            <a-select-option :value="3" v-if="status==3">已结束</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
          <a-button v-if="status==1" type="primary" @click="handleSubmit" :loading="submitLoading">保存设置</a-button>
          <a-button v-if="status==2" @click="showConfirm">提前结束</a-button>
          <a-button @click="goBack">返回</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-card>
    <selected-product-dialog
      title='选择指定分销员店铺'
      :show="showSelectedDialog"
      ref="pageDialogList"
      row-key="staffId"
      :rowSelection="{ selectedRowKeys: selectedGroupRowKeys, onChange: onShopChange }"
      :requestPromise="getMemberListPromise"
      @close="onCloseShopDialog"
      :columns="getColumns()"
      :itemNames="['search_staffName','search_shopName']"
      :query-params="selectedQueryParams"
      extraPaginationName="extraPaginationName"
      :customPagination="true"
    >
      <a-form-item
        label="姓名"
        slot="search_staffName" v-bind="currentDialogLayout">
        <a-input
          v-model="selectedQueryParams.staffName"
          style="width: 170px"
          placeholder="请输入姓名"
        ></a-input>
      </a-form-item>
      <a-form-item
        label="店铺名称"
        slot="search_shopName"
        v-bind="currentDialogLayout">
        <a-input
          v-model="selectedQueryParams.staffShopName"
          style="width: 170px"
          placeholder="请输入店铺名称"
        ></a-input>
      </a-form-item>
      <template slot="extraPaginationName" v-if='selectedGroupRowKeys&&selectedGroupRowKeys.length>0'>
        <a-button type="primary" @click="onCheckAll">确定</a-button>
      </template>
      <span slot="memberState" slot-scope="rowItem">
          <template v-if="rowItem.record.staffAudit===1">
              <span>{{ rowItem.record.staffStatus|staffStatusName }}</span>
          </template>
          <template v-else>{{ rowItem.record.staffAudit|staffAuditName }}</template>
        </span>
    </selected-product-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog'

export default {
  name: 'NewMemberCard',
  components: {
    SelectedProductDialog
  },
  data() {
    let checkNum = (rule, value, callback) => {
      if (Number(value) > Number(5000)) {
        callback(new Error('数量必须1-5000之间'))
      } else {
        callback()
      }
    }
    let checkCountNum = (rule, value, callback) => {
      if (Number(value) > Number(10000)) {
        callback(new Error('数量必须1-10000之间'))
      } else {
        callback()
      }
    }
    let checkDayNum = (rule, value, callback) => {
      if (Number(value) > Number(1096)) {
        callback(new Error('数量必须1-1096之间'))
      } else {
        callback()
      }
    }
    let checkCommissionPrice = (rule, value, callback) => {
      if (Number(value) >= Number(this.ruleForm.denomination)) {
        callback(new Error('必须小于面额'))
      } else {
        callback()
      }
    }
    return {
      moment,
      selectedQueryParams: {
        searchName: '',
        proId: ''
      },
      cardId: this.$route.query.cardId,
      status: this.$route.query.status,
      showSelectedDialog: false,
      actionImageUrl: this.getAppConfig().baseUrl + 'base/upload',
      submitLoading: false,
      currentDialogLayout: {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 }
      },
      currentFormLayout: {
        labelCol: {
          xxl: { span: 3 },
          xl: { span: 3 },
          lg: { span: 3 },
          sm: { span: 3 },
          md: { span: 5 },
          xs: { span: 10 }
        },
        wrapperCol: {
          xxl: { span: 21 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 21 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 21 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 21 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 16 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 14 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        },
        offsetCol: {
          xxl: { offset: 3 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { offset: 3 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { offset: 3 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { offset: 3 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { offset: 5 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { offset: 10 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      },
      ruleForm: {
        cutOffDate: undefined,
        cutOffDateStr: '',
        cardType: 1,// 卡类型 1电子卡,2实体卡 ,
        commission: '',// 元，小于面额数值，仅对电子卡销售时有效 ,
        denomination: '',// 面额:元，1-5000正整数 ,
        id: '',// 会员卡Id 新增填空 ,
        image: '',// 图片地址 ,
        name: '',// 会员卡名称 ,
        notice: '',// 使用须知 ,
        productCatalog: [],// 可用品类(多个以英文逗号隔开) 5百货,2酒店,1门票,8抢购 ,
        productSource: [],// 可用商品来源(多个以英文逗号隔开) 0自有产品 1平台直采 2云仓分销 ,
        releaseNum: '',// 发行数量 正整数数值1-100000 ,
        releaseType: 1,// 发行类型 1不限数量,2有限数量 ,
        saleChannels: ['1'],// 销售渠道(多个以英文逗号隔开) 1官方店可售 2分销员店可售 ,
        status: 1,// 状态 1未开始,2进行中,3已结束 ,
        validityKey: 1,// 有效期类型 1长期有效,2有效期至,3激活后X天 ,
        validityValue: '',// 有效期至的可设置结束日期/激活后X天,天数最大为730
        commissionSettlement: 1,
        writeOffChannel: 3,
        staffIds: []
      },
      disabledDate(current) {
        // Can not select days before today and today
        return current && current < moment().startOf('day')
      },
      rules: {
        name: [
          { required: true, message: '请输入会员卡名称', trigger: 'blur' }
        ],
        denomination: [
          { required: true, message: '请输入面额', trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: '请输入正确的面额', trigger: 'blur' },
          { validator: checkNum, trigger: 'blur' }
        ],
        commission: [
          { pattern: /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/, message: '请输入正确的金额', trigger: 'blur' },
          { validator: checkCommissionPrice, trigger: 'blur' }
        ],
        releaseNum: [
          { required: true, message: '请选择发行数量', trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: '输入有误', trigger: 'blur' },
          { validator: checkCountNum, trigger: 'blur' }
        ],
        validityValue: [
          { required: true, message: '请输入有效天数', trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: '输入有误', trigger: 'blur' },
          { validator: checkDayNum, trigger: 'blur' }
        ],
        cutOffDate: [
          { required: true, message: '请选择有效日期', trigger: 'change' }
        ],
        saleChannels: [
          { type: 'array', required: true, message: '请选择销售渠道', trigger: 'change' }
        ],
        productCatalog: [
          { type: 'array', required: true, message: '请选择可用品类', trigger: 'change' }
        ],
        productSource: [
          { type: 'array', required: true, message: '请选择可用商品来源', trigger: 'change' }
        ],
        notice: [
          { required: true, message: '请输入使用须知', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ],
        staffIds: [
          { required: true, message: '请选择指定分销员店铺', trigger: 'change' }
        ]
      },
      proCataLogIdList: [],
      selectedGroupRowKeys: [],
      selectedRows: []
    }
  },
  mounted() {
    this.cardId = this.$route.query.cardId
    this.status = this.$route.query.status
    this.getCardInfo()
    this.getProCataLogId()
  },
  methods: {
    getCataLogIdList() {
      let list = [...this.proCataLogIdList]
      if (this.cardId == 0) {
        list = this.proCataLogIdList.filter(item => item.enabled)
      }
      return list
    },
    handleStaffClose(removedTag) {
      this.ruleForm.staffIds = this.ruleForm.staffIds.filter(tag => tag.staffId !== removedTag)
    },
    onShopChange(selectedRowKeys, selectedRows) {
      this.selectedGroupRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    onCheckAll() {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.error('请选择店铺')
        return false
      }
      let firstArr = []
      let secondArr = []
      this.selectedRows.forEach(item => {
        firstArr.push({
          staffId: item.staffId,
          shopName: item.staffShopName
        })
      })
      if (this.ruleForm.staffIds && this.ruleForm.staffIds.length > 0) {
        this.ruleForm.staffIds.forEach(item => {
          secondArr.push({
            staffId: item.staffId,
            shopName: item.shopName
          })
        })
      }
      let arr = firstArr.concat(secondArr)

      this.ruleForm.staffIds = this.unique(arr)
      this.onCloseShopDialog()
    },
    unique(arr) {
      let map = new Map()
      for (let item of arr) {
        if (!map.has(item.staffId)) {
          map.set(item.staffId, item)
        }
      }
      return [...map.values()]
    },
    onCloseShopDialog() {
      this.showSelectedDialog = false
    },
    onShowShopDialog() {
      this.selectedGroupRowKeys = []
      this.selectedRows = []
      this.showSelectedDialog = true
    },
    getMemberListPromise(params) {
      params.staffStatus = 1
      return this.getHttpServices().getUserService().post('staff/v2/getStaffList', params)
    },
    onChangeRadio(e) {
      if (e.target.value > 3) {
        this.ruleForm.staffIds = []
      }
    },
    onChangeType(e) {
      if (e.target.value === 2) {
        this.ruleForm.saleChannels = []
      } else {
        this.ruleForm.saleChannels = ['1']
      }
      this.ruleForm.releaseType = e.target.value
      this.ruleForm.releaseNum = ''
    },
    getColumns() {
      return [
        {
          title: 'ID',
          dataIndex: 'staffId'
        },
        {
          title: '店铺名称',
          dataIndex: 'staffShopName'
        },
        {
          title: '姓名',
          dataIndex: 'staffName'
        },
        {
          title: '状态',
          dataIndex: 'memberState',
          scopedSlots: { customRender: 'memberState' }
        }
      ]
    },
    goBack() {
      this.$router.go(-1)
    },
    // 获取商品状态
    getProCataLogId() {
      this.getHttpServices().getUserService().get('member/v2/card/getProCatalogId')
        .then(res => {
          this.proCataLogIdList = res && res.length > 0 && res.filter(item => item.code != 7)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        return
      }
      if (info.file.status === 'done') {
        const url = this.getLatestUrlFromFileList(info.fileList)
        // Get this url from response in real world.
        this.ruleForm.image = url
      }
    },
    getLatestUrlFromFileList(fileList) {
      if (fileList && fileList.length > 0) {
        const lastIndex = fileList.length - 1
        if (fileList[lastIndex] && fileList[lastIndex].response) {
          return fileList[lastIndex].response.data
        }
      }
      return ''
    },
    beforeUploadFile(file) {
      const isJPG = file.type === 'image/jpeg'
      const isJPEG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 1
      if (!isJPG && !isPNG && !isJPEG) {
        this.$message.error('请选择正确的图片格式上传!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 1MB!')
        return false
      }
      return true
    },
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getListPromise==', params)
      return this.getHttpServices().getServerApiService().post('coupon/setting/getCouponSettingList', params)
    },
    resetForm() {
      this.$refs.ruleForm.resetFields()
    },
    //领取日期
    onDateChange(dates, dateStrArr) {
      this.getLogUtils().logWithTag('onDateChange', dates)
      this.getLogUtils().logWithTag('onDateChange', dateStrArr)
      this.ruleForm.cutOffDate = dates
      this.ruleForm.cutOffDateStr = dateStrArr
      this.ruleForm = { ...this.ruleForm }
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
      if (this.submitFormData.validityKey == 2) {
        this.submitFormData.validityValue = this.submitFormData.cutOffDateStr
      }
      this.submitFormData.commission = this.submitFormData.cardType == 1 ? this.submitFormData.commission : null
      this.submitFormData.productCatalog = this.submitFormData.productCatalog.join(',')
      this.submitFormData.productSource = this.submitFormData.productSource.join(',')
      this.submitFormData.saleChannels = this.submitFormData.saleChannels && this.submitFormData.saleChannels.length > 0 ? this.submitFormData.saleChannels.join(',') : ''
      this.submitLoading = true
      delete this.submitFormData.cutOffDateStr
      delete this.submitFormData.cutOffDate
      this.getHttpServices().getUserService().post('member/v2/card/saveMembershipCard', this.submitFormData).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.ruleForm.id = res
        this.$message.success('会员卡保存成功')
        this.goCardList()
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    // 获取信息
    getCardInfo() {
      if (this.cardId != 0) {
        this.getHttpServices().getUserService().post('member/v2/card/getMembershipCardDetail', {
          membershipCardId: this.cardId
        }).then(res => {
          this.getLogUtils().logWithTag('getCardInfo', res)
          this.ruleForm = res
          if (res.productCatalog) {
            this.ruleForm.productCatalog = res.productCatalog.split(',')
          }
          if (res.saleChannels) {
            this.ruleForm.saleChannels = res.saleChannels.split(',')
          }
          if (res.productSource) {
            this.ruleForm.productSource = res.productSource.split(',')
          }
          if (res.validityKey == 2) {
            this.ruleForm.cutOffDateStr = res.validityValue
            this.ruleForm.cutOffDate = moment(res.validityValue, 'YYYY-MM-DD')
          }
        }).catch(reason => this.showNetWorkErrorMessage(reason))
      }
    },
    // 提前结束功能
    showConfirm() {
      let that = this
      this.$confirm({
        title: '此操作将提前结束该功能?，是否继续',
        onOk() {
          that.overbtn()
        },
        onCancel() {
          that.$message.info('已取消')
        }
      })
    },
    // 提前结束
    overbtn() {
      this.getHttpServices().getUserService().post('member/v2/card/closeMembershipCard', {
        membershipCardId: this.cardId
      }).then(res => {
        this.getLogUtils().logWithTag('overbtn', res)
        this.$message.success('会员卡提前结束成功')
        this.goCardList()
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    goCardList() {
      setTimeout(() => {
        this.$router.push({
          name: 'MemberLists',
          query: {
            updateFlag: true
          }
        })
      }, 500)
    }
  }
}
</script>
<style scoped lang="less">
@import url('../../CustomPage');

.ant-btn + .ant-btn {
  margin-left: 10px;
}

.maxW250 {
  max-width: 250px;
}

.pl5 {
  padding-left: 5px;
}

.pr5 {
  padding-right: 5px;
}

.lh18 {
  line-height: 18px;
}
</style>
<style lang="less">
.upload-box-card {
  .avatar-uploader > .ant-upload {
    width: 80px;
    height: 80px;
  }

  .img-avatar {
    width: 100px;
    height: 100px;
  }
}
</style>